export default __webpack_public_path__ + "static/media/queshengye-kecheng.0260f582.png";